import { Injectable } from "@angular/core";
import { global } from "../global";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, catchError, of, throwError } from "rxjs";

@Injectable({
    providedIn: 'root',
})

export class ibrkServices {

    public urlApiibrk: string;

    constructor(private _httpclient: HttpClient){
        this.urlApiibrk = global.ApiibrkUlr;
    }

/*     apiGetIbrk(endpoint: any): Observable<any>{
        let url: string = `${this.urlApiibrk}${endpoint}`;    
        return this._httpclient.get<any>(url);
    } */
    apiPostIbrk(endpoint: any, data: any): Observable<any>{
        let url: string = `${this.urlApiibrk}${endpoint}`;    
        return this._httpclient.post<any>(url,data);
    }

    apiGetIbrk(endpoint: any): Observable<any> {
        let url: string = `${this.urlApiibrk}${endpoint}`;
        return this._httpclient.get<any>(url).pipe(
          catchError((error: HttpErrorResponse) => {
            // Check if the error is a CORS error
            if (error.error instanceof ProgressEvent && error.url) {
              console.log('Error de CORS:');
              return of(null); // Otra opción es retornar null
            }
            return throwError(error);
          })
        );
      }
    apiDeleteIbrk(endpoint: any){
      let url: string = `${this.urlApiibrk}${endpoint}`;    
        return this._httpclient.delete<any>(url);
    }
}